import axios from "axios";
import config from '../constants/config';

//Create a instance
const apiUrl = config.apiBaseUrl;
const instance = axios.create({
    baseURL: apiUrl,
    headers: {
        'content-type': 'application/json',
    }
});

const doAPI = {
    //Get data from the server by method = GET
    getData: (URL, parameters = {}) =>
        instance({
            'method': 'GET',
            'url': URL,
            'params': parameters
        }),
    //Post data on the server by method = POST
    postData: (URL, parameters = {}) =>
        instance({
            'method': 'POST',
            'url': URL,
            'data': parameters
        }),
};

export default doAPI;